var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCat = function SvgCat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15V17.5",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 11.875C7.08027 11.875 7.5 11.4553 7.5 10.9375C7.5 10.4197 7.08027 10 6.5625 10C6.04473 10 5.625 10.4197 5.625 10.9375C5.625 11.4553 6.04473 11.875 6.5625 11.875Z",
    fill: "#919191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 11.875C13.9553 11.875 14.375 11.4553 14.375 10.9375C14.375 10.4197 13.9553 10 13.4375 10C12.9197 10 12.5 10.4197 12.5 10.9375C12.5 11.4553 12.9197 11.875 13.4375 11.875Z",
    fill: "#919191"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.75V6.875",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.75L10 15L8.75 13.75",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.1416V6.8752",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.1416V6.8752",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28125 5.28077C6.65334 4.28553 8.30497 3.7496 10 3.7496C11.695 3.7496 13.3467 4.28553 14.7187 5.28077L16.4328 3.30889C16.5201 3.22148 16.6314 3.1619 16.7526 3.1377C16.8737 3.11349 16.9993 3.12574 17.1135 3.17289C17.2277 3.22004 17.3254 3.29998 17.3942 3.40261C17.463 3.50525 17.4998 3.62596 17.5 3.74952V10.6245C17.5 14.4214 14.1406 17.4995 10 17.4995C5.85938 17.4995 2.5 14.4214 2.5 10.6245V3.74952C2.4999 3.62583 2.53651 3.5049 2.60517 3.40203C2.67384 3.29916 2.77149 3.21897 2.88576 3.17163C3.00002 3.12428 3.12576 3.1119 3.24707 3.13606C3.36837 3.16022 3.47978 3.21982 3.56719 3.30733L5.28125 5.28077Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCat;